import { tabClasses, tabsClasses } from "@mui/material"

export const textTab = {
  [`& .${tabClasses.root}`]: {
    fontSize: { xs: 20, md: 24 },
    fontWeight: 400,
    p: 2,
    flexBasis: "50%",
    backgroundColor: "selectInputBackground",
  },
  [`& .${tabClasses.selected}`]: {
    backgroundColor: "white",
  },
  [`& .${tabsClasses.indicator}`]: {
    backgroundColor: "unset",
  },
}

export const contentWrapper = {
  px: { xs: 2, md: 3, lg: 4 },
  pt: { xs: 2, md: 3, lg: 4 },
  pb: 2,
}

export const tabBorderTopLeft = {
  borderTopLeftRadius: 16,
}

export const tabBorderTopRight = {
  borderTopRightRadius: 16,
}

export const semiBoldTextEnd = {
  fontWeight: 600,
  textAlign: "end",
}

export const supplyAPYText = {
  ...semiBoldTextEnd,
  color: "green",
}

export const borrowLimitText = {
  ...semiBoldTextEnd,
  color: "orange",
}

export const liquidationThresholdText = {
  ...semiBoldTextEnd,
  color: "thresholdRed",
}

export const convertedText = {
  fontSize: 12,
  color: "grey",
}

export const helperText = {
  mb: 3,
  textAlign: "center",
}

export const buttonSubmit = {
  width: "100%",
  lineHeight: "2rem",
  fontSize: 20,
  fontWeight: 700,
}
